import Vue from "vue";
import VueI18n from "vue-i18n";
import eleLocale from "element-ui/lib/locale";
import elementEnLocale from "element-ui/lib/locale/lang/en"; // element-ui lang
import elementZhLocale from "element-ui/lib/locale/lang/zh-CN";
import elementIdLocale from "element-ui/lib/locale/lang/id";
import elementItLocale from "element-ui/lib/locale/lang/it"
import elementDeLocale from "element-ui/lib/locale/lang/de"
import elementFrLocale from "element-ui/lib/locale/lang/fr"
import elementRuLocale from "element-ui/lib/locale/lang/ru-RU"
import elementTrLocale from "element-ui/lib/locale/lang/tr-TR"
import elementUzLocale from "../i18n/langs/EL_UZ"
import elementNlLocale from "element-ui/lib/locale/lang/nl"
import elementPlLocale from "element-ui/lib/locale/lang/pl"
import elementEsLocale from "element-ui/lib/locale/lang/es"
import elementArLocale from "element-ui/lib/locale/lang/ar"
// import elementPtLocale from 'element-ui/lib/locale/lang/pt'
import en_US from "./langs/en_US"; // 英语
import zh_CN from "./langs/zh_CN"; // 中文
import en_ID from "./langs/en_ID"; // 印尼语
import it_IT from "./langs/it_IT"; // 意大利语
import de_DE from "./langs/de_DE"; // 德语
import fr_FR from "./langs/fr_FR"; // 法语
import ru_RU from "./langs/ru_RU"; // 俄语
import tr_TR from "./langs/tr_TR"; // 土耳其语
import uz_UZ from "./langs/uz_UZ"; // 乌兹别克语
import nl_NL from "./langs/nl_NL"; // 荷兰语
import pl_PL from "./langs/pl_PL"; // 波兰语
import es_ES from "./langs/es_ES";
import ar_SA from "./langs/ar_SA";
// import pt_BR from './langs/pt_BR';
import cnurl from "../assets/img/cn.png";
import enurl from "../assets/img/uk.png";
import idurl from "../assets/img/id.png";
import deurl from "../assets/img/de.png";
import iturl from "../assets/img/it.png";
import frurl from "../assets/img/fr.png";
import ruurl from "../assets/img/ru.png";
import trurl from "../assets/img/tr.png";
import uzurl from "../assets/img/uz.png";
import nlurl from "../assets/img/nl.png";
import plurl from "../assets/img/pl.png";
import esurl from "../assets/img/es.png";
import arurl from "../assets/img/sr.png";

Vue.use(VueI18n);

let _lang = Symbol("lang");
class Lang {
  constructor() {
    // 当前语言
    // if (window.location.hostname== "energon.dessmonitor.com") {
    //   this[_lang] = localStorage.getItem("language") ||"ru_RU"
    // }else{
    //   this[_lang] =
    //     localStorage.getItem("language") ||
    //     navigator.language.replace("-", "_") ||
    //     "en_US";
    // }
    if (localStorage.getItem("language")) {
      this[_lang] = localStorage.getItem("language")
    }else if (navigator.language=="zh"||navigator.language=="zh-CN"||navigator.language=="zh_CN"||navigator.language=="zh-TW"||navigator.language=="zh-HK") {
      this[_lang] = "zh_CN"
    }else{
      this[_lang] = "en_US"
    }
    // 可选语言列表
    this.langList = [
      {
        value: "en_US",
        name: "English",
        config: en_US,
        elementConfig: elementEnLocale,
        imgurl: enurl,
      },
      {
        value: "zh_CN",
        name: "中文",
        config: zh_CN,
        elementConfig: elementZhLocale,
        imgurl: cnurl,
      },
      {
        // 印尼语
        value: "en_ID",
        name: "Indonesian",
        config: en_ID,
        elementConfig: elementIdLocale,
        imgurl: idurl,
      },
      {
        // 意大利语
        value: "it_IT",
        name: "Italiano",
        config: it_IT,
        elementConfig: elementItLocale,
        imgurl: iturl,
      },
      {
        // 德语
        value: "de_DE",
        name: "Deutsch",
        config: de_DE,
        elementConfig: elementDeLocale,
        imgurl: deurl,
      },
      {
        // 法语
        value: "fr_FR",
        name: "French",
        config: fr_FR,
        elementConfig: elementFrLocale,
        imgurl: frurl,
      },
      {
        // 俄语
        value: "ru_RU",
        name: "Russian",
        config: ru_RU,
        elementConfig: elementRuLocale,
        imgurl: ruurl,
      },
      {
        // 土耳其
        value: "tr_TR",
        name: "Turkish",
        config: tr_TR,
        elementConfig: elementTrLocale,
        imgurl: trurl,
      },
      {
        // 乌兹别克语
        value: "uz_UZ",
        name: "Uzbek",
        config: uz_UZ,
        elementConfig: elementUzLocale,
        imgurl: uzurl,
      },
      {
        // 荷兰语
        value: "nl_NL",
        name: "Dutch",
        config: nl_NL,
        elementConfig: elementNlLocale,
        imgurl: nlurl,
      },
      {
        // 波兰语
        value: "pl_PL",
        name: "Polish",
        config: pl_PL,
        elementConfig: elementPlLocale,
        imgurl: plurl,
      },
      {
        // 西班牙语
        value: "es_ES",
        name: "Español",
        config: es_ES,
        elementConfig: elementEsLocale,
        imgurl: esurl,
      },
      {
        // 阿拉伯语
        value: "ar_SA",
        name: "العربية",
        config: ar_SA,
        elementConfig: elementArLocale,
        imgurl: arurl,
      },
      // {
        // 葡萄牙语
      //   value: 'pt_BR',
      //   name: 'Português',
      //   config: pt_BR,
      //   elementConfig: elementPtLocale
      // }
    ];

    this.init();
  }
  init() {
    let messages = {};
    this.langList.forEach((item) => {
      messages[item.value] = {
        ...item.config,
        ...item.elementConfig,
      };
    });

    // let locale = 'en_US'
    let locale = this[_lang];
    this.i18n = new VueI18n({
      locale,
      messages,
    });
    eleLocale.i18n((key, value) => this.i18n.t(key, value));
  }
  // 获取当前设置语言
  get currentLang() {
    return this[_lang];
  }
  // 设置当前语言
  set currentLang(newLang) {
    localStorage.setItem("language", newLang);
    this[_lang] = newLang;
    window.location.reload();
  }
}

const lang = new Lang();
let { i18n } = lang;

export default lang;
export { i18n };
